const defaultRecursiveCleanConfig = {
    ignoreNull: false,
    removeEmptyString: false,
    ignoreEmptyArrays: false,
};
export function recursiveClean(obj, config = defaultRecursiveCleanConfig) {
    Object.keys(obj).forEach((key) => {
        const value = obj[key];
        const type = typeof value;
        if (value === null) {
            if (!config.ignoreNull) {
                delete obj[key];
            }
        }
        else if (type === 'object') {
            if (!(obj[key] instanceof Date)) {
                recursiveClean(value, config);
                if (!Object.keys(value).length) {
                    if (!Array.isArray(obj[key])) {
                        if (!config.ignoreEmptyObject) {
                            delete obj[key];
                        }
                    }
                    else {
                        if (!config.ignoreEmptyArrays) {
                            delete obj[key];
                        }
                        else {
                            obj[key] = [];
                        }
                    }
                }
            }
        }
        else if (type === 'undefined') {
            delete obj[key];
        }
        else if (value === '' && config.removeEmptyString) {
            delete obj[key];
        }
    });
    return obj;
}
//# sourceMappingURL=object-helper.utils.js.map